class CurrencyConverter {
    constructor() {
        // this.fromCurrency = document.querySelector('form.converter-block__form input[name="first"]');
        // this.fromCurrencySelect = document.querySelector('#fromCurrencySelect');
        // this.toCurrency = document.querySelector('form.converter-block__form input[name="second"]');
        // this.toCurrencySelect = document.querySelector('#toCurrencySelect');
        this.bankOptions = document.querySelectorAll('#bankSelect ul.basic-select__list li');
        this.convertButton = document.querySelector('#convert-button');
        this.bankValue = document.querySelector('#bank');

        // this.fromCurrency.addEventListener('click', this.openDropdown.bind(this));
        this.bankOptions.forEach((option) => {
            option.addEventListener('click', this.changeBank.bind(this));
        });

        this.convertButton.addEventListener('click', this.convert.bind(this));

    }

    addToURL(param, value) {
        //     add value to url
        const url = new URL(window.location.href);
        url.searchParams.set(param, value);
        window.history.pushState({}, '', url);
    }

    renewCurrencyDropdowns(currenciesList) {
        document.querySelectorAll('.converter-block__form-input').forEach((item, i) => {
            const selected_curr = item.querySelector('.converter-dropdown__selected span');
            if (!currenciesList.includes(selected_curr.textContent.toLowerCase())) {
                selected_curr.textContent = currenciesList[i].toUpperCase();
            }

            const select = item.querySelector('.currency-select');
            select.innerHTML = '';
            currenciesList.forEach((currency) => {
                const option = document.createElement('li');
                option.dataset.value = currency;
                option.textContent = currency.toUpperCase();
                select.appendChild(option);
            })
        })

    }

    changeBank(event) {
        let bank = event.target.dataset.value;
        this.bankValue.dataset.value = bank;
        this.addToURL('bank', bank);
        fetch(`/api/currencies/bank_currencies?bank=${bank}`)
            .then((response) => response.json())
            .then((data) => {
                this.renewCurrencyDropdowns(data.currencies);
            })
    }

    convert(event) {
        event.preventDefault();
        const fromCurrency = document.querySelector('#from-currency').textContent.toLowerCase();
        const toCurrency = document.querySelector('#to-currency').textContent.toLowerCase();
        const amount = document.querySelector('#amount').value;
        const bank = document.querySelector('#bank').dataset.value;

        fetch(`/api/currencies/convert?from=${fromCurrency}&to=${toCurrency}&amount=${amount}&bank=${bank}`)
            .then((response) => response.json())
            .then((data) => {
                // remain only two signs after dot
                const result = data.converted_amount.toFixed(2);
                document.querySelector('#converted-amount').value = result;
                const fromCurrPreview = document.querySelector('#preview_from-curr');
                fromCurrPreview.textContent = `${amount} ${fromCurrency.toUpperCase()}`;
                const toCurrPreview = document.querySelector('#preview_to-curr');
                toCurrPreview.textContent = `${result} ${toCurrency.toUpperCase()}`;
            })
    }
}

const currencyConverter = new CurrencyConverter();
